import React from "react";
import { FiKey } from "react-icons/fi";
import BuyElectricityCard from "../../components/landing/buy-card";
import RetrieveTokenModal from "../../components/modals/guest/retrieve-token-modal";

// What shows on pay.* : just the centred hero (header and footer come from the layout).
export default function PayHome() {
  const [meterId, setMeterId] = React.useState("");
  const [retrieveOpen, setRetrieveOpen] = React.useState(false);

  return (
    <section className="relative flex min-h-[calc(100vh-240px)] items-center overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(60%_50%_at_50%_0%,rgba(225,170,43,0.20),transparent),radial-gradient(50%_45%_at_0%_100%,rgba(1,13,85,0.08),transparent)]"
      />
      <div className="mx-auto flex w-[92%] max-w-[640px] flex-col items-center gap-8 py-16 text-center">
        <span className="inline-flex items-center rounded-full bg-secondary-dark/15 px-3.5 py-1 text-[13px] font-semibold text-[#9a6f08]">
          Central vending for communities
        </span>
        <h1 className="text-[40px] font-extrabold leading-[1.05] tracking-tight text-primary-dark sm:text-5xl lg:text-[60px]">
          Buy electricity in{" "}
          <span className="bg-gradient-to-r from-[#E1AA2B] to-[#c4791a] bg-clip-text text-transparent">minutes</span>
          , not queues.
        </h1>
        <p className="max-w-[520px] text-lg leading-relaxed text-[#5b5f73]">
          Enter your meter ID, transfer the amount and get your token.
        </p>

        <BuyElectricityCard onMeterChange={setMeterId} className="max-w-[540px] text-left" />

        <button
          type="button"
          onClick={() => setRetrieveOpen(true)}
          className="flex h-[52px] items-center justify-center gap-2 whitespace-nowrap rounded-full border border-secondary-dark/60 bg-secondary-light px-7 text-[15px] font-semibold text-primary-dark transition hover:bg-secondary-dark/20"
        >
          <FiKey />
          Retrieve token
        </button>
      </div>

      {retrieveOpen && (
        <RetrieveTokenModal initialMeterId={meterId} onClose={() => setRetrieveOpen(false)} />
      )}
    </section>
  );
}
